import { ModalAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnAfterFetch, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FetchEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { cast } from '../../utils/cast-helpers';
import { DelayedExecutor } from '../../utils/workaround-utils';
import BaseController from '../BaseController';

interface NoticeTermDTO {
  content: string;
  title: string;
}

@Controller({ component: 'modal-account-creation-privacy', fragment: 'account-creation-privacy-modal' })
export default class AccountCreationPrivacyModalController extends BaseController {

  private delayedExecutor: DelayedExecutor<NoticeTermDTO> = new DelayedExecutor();

  @OnClose({ target: 'modal-account-creation-privacy' })
  onCloseModalAccountCreationPrivacy(): void {
    this.historyService.back();
  }

  @OnMount({ target: 'modal-account-creation-privacy' })
  onMountModal(evt: MountEvent): void {
    const target: ModalAPI = cast(evt.target);

    this.delayedExecutor.onCompleted(e => {
      target.setTitle(e.title);
    })
  }

  @OnAfterFetch({ target: 'fetch-data' })
  onAfterFetchUpdateModalTitle(event: FetchEvent): void {
    this.delayedExecutor.completeNow(cast(event.data));
  }

}